import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueMui,
  greenMui,
  greyMui,
  orangeMui,
  purpleMui,
  redMui,
  rydeColors,
} from "@ryde/theme";

import { DrawerContentStyled } from "../drawer";

export const RideHistoryLogDrawerContentStyled = styled(
  DrawerContentStyled,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-history-log-drawer-content-styled",
})`
  padding-inline-start: 22px;
  padding-inline-end: 22px;
  display: flex;
  flex-direction: column;

  .search-section {
    border-radius: 0;
    padding-inline-start: 8px;
    padding-inline-end: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .ride-history-log__notices {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0 22px 8px;
    padding: 8px 12px;
    border-left: 3px solid ${rydeColors.orange};
    background-color: ${rydeColors.lightGreyBorder};
    color: ${rydeColors.midGrey};
    font-size: 12px;
  }

  .ride-history-log__grid-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ride-history-log__empty-state {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
  }

  .ride-history-log__empty-state-message {
    background-color: ${greyMui._50};
    border: 1px solid ${greyMui._200};
    border-radius: 8px;
    padding: 32px 40px;
    color: ${rydeColors.grey};
    font-size: 16px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    max-width: 500px;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    min-height: 140px;
    justify-content: center;
  }

  .ride-history-log__empty-state-icon {
    font-size: 32px;
    color: ${rydeColors.grey};
    opacity: 0.6;
  }

  .ride-history-log__grid {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    min-width: 0;
  }

  .ride-history-log__grid-header {
    display: flex;
    border-bottom: 1px solid ${greyMui._300};
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: ${rydeColors.white};
    min-width: max-content;
  }

  .ride-history-log__grid-header-cell {
    padding: 10px 12px;
    font-size: 14px;
    color: ${rydeColors.grey};
    min-width: 180px;
    display: flex;
    align-items: center;
  }
  .ride-history-log__grid-header-cell_expanded {
    min-width: 44px;
    width: 44px;
  }

  .ride-history-log__grid-body {
    flex: 1;
    padding-top: 15px;
  }

  .ride-history-log__grid-row {
    display: flex;
    cursor: pointer;
    transition: background-color 0.2s ease;
    min-width: max-content;
  }

  .ride-history-log__grid-cell {
    flex: 1;
    padding: 10px 12px;
    font-size: 13px;
    line-height: 1.6;
    min-width: 180px;
    width: 180px;
    min-height: 40px;
    display: flex;
    align-items: center;
    overflow: visible;

    > span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 4px;
      line-height: 1.6;
    }
  }
  .ride-history-log__grid-cell_was-changed {
    color: ${rydeColors.darkerRed};
    font-weight: 700;
    text-decoration: underline;
  }

  .ride-history-log__grid-cell_unchanged {
    color: ${greyMui._400};
  }

  .ride-history-log__grid-cell_expanded {
    flex: 0;
    min-width: 44px;
    width: 44px;
    padding: 0 0 0 16px;
  }

  .ride-history-log__grid-row-details {
    overflow: hidden;
  }

  .ride-history-log__grid-row-details-content {
    padding-inline-start: 33px;
    padding-bottom: 15px;
    font-size: 13px;
  }

  .Collapse-Icon {
    color: ${rydeColors.darkBlue};
  }

  .ride-history-log__metadata-labels {
    margin-bottom: 8px;
    margin-inline-start: 6px;
    font-size: 13px;
  }

  .ride-history-log__metadata-labels .ride-history-log__metadata {
    margin-bottom: 0;
    margin-inline-start: 0;
  }

  /* Beside the expand / collapse buttons the row sets the spacing. */
  .entityPropertiesControls__extra .ride-history-log__metadata-labels {
    margin: 0;
  }

  .ride-history-log__metadata {
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 13px;
    margin-inline-start: 6px;
    padding: 4px 8px;
    border-radius: 9px;
    border: 1px solid;
    display: inline-block;

    &.ride-history-log__metadata--created {
      background-color: ${greenMui._50};
      color: ${greenMui._700};
      border-color: ${greenMui._200};
    }

    &.ride-history-log__metadata--deleted {
      background-color: ${purpleMui._50};
      color: ${purpleMui._700};
      border-color: ${purpleMui._200};
    }

    &.ride-history-log__metadata--updated {
      background-color: ${blueMui._50};
      color: ${blueMui._700};
      border-color: ${blueMui._200};
    }

    &.ride-history-log__metadata--syncer-push {
      background-color: ${purpleMui._100};
      color: ${purpleMui._800};
      border-color: ${purpleMui._300};
    }
  }

  .ride-history-log__tabs-container {
    display: flex;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-inline-start: 1px;
  }

  .ride-history-log__tabs {
    .MuiToggleButton-root {
      min-width: 140px;
      width: auto;
      padding-inline-start: 16px;
      padding-inline-end: 16px;
      height: 32px;
      text-transform: none;
      font-size: 14px;
      font-weight: 500;
      border: 1px solid ${greyMui._300};
      color: ${rydeColors.grey};
      background-color: ${rydeColors.white};
      transition: all 0.2s ease;

      &:hover {
        background-color: ${greyMui._50};
      }

      &.Mui-selected {
        background-color: ${purpleMui._50};
        color: ${purpleMui._700};
        border-color: ${purpleMui._200};

        &:hover {
          background-color: ${purpleMui._100};
        }
      }

      &.Mui-disabled {
        background-color: ${purpleMui._50};
        color: ${purpleMui._700};
        border-color: ${purpleMui._200};
        opacity: 1;
      }
    }
  }

  .processes-history__grid-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .processes-history__empty-state {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
  }

  .processes-history__empty-state-message {
    background-color: ${greyMui._50};
    border: 1px solid ${greyMui._200};
    border-radius: 8px;
    padding: 32px 40px;
    color: ${rydeColors.grey};
    font-size: 16px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    max-width: 500px;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    min-height: 140px;
    justify-content: center;
  }

  .processes-history__empty-state-icon {
    font-size: 32px;
    color: ${rydeColors.grey};
    opacity: 0.6;
  }

  .processes-history__grid {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    min-width: 0;
  }

  .processes-history__grid-header {
    display: flex;
    border-bottom: 1px solid ${greyMui._300};
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: ${rydeColors.white};
    min-width: max-content;
  }

  .processes-history__grid-header-cell {
    flex: 1;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 600;
    color: ${rydeColors.grey};
    min-width: 120px;
    display: flex;
    align-items: center;
  }

  .processes-history__grid-header-cell_expanded {
    flex: 0;
    min-width: 44px;
    width: 44px;
  }

  .processes-history__grid-body {
    flex: 1;
    padding-top: 15px;
  }

  .processes-history__grid-row {
    display: flex;
    cursor: pointer;
    transition: background-color 0.2s ease;
    min-width: max-content;

    &:hover {
      background-color: ${greyMui._50};
    }
  }

  .processes-history__grid-row--expanded {
    background-color: ${greyMui._50};
  }

  .processes-history__grid-cell {
    flex: 1;
    padding: 8px 12px;
    font-size: 13px;
    min-width: 120px;
    display: flex;
    align-items: center;
    overflow: hidden;

    > span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }

  .processes-history__grid-cell_expanded {
    flex: 0;
    min-width: 44px;
    width: 44px;
    padding: 0 0 0 16px;
  }

  .processes-history__grid-row-details {
    overflow: hidden;
  }

  .processes-history__grid-row-details-content {
    padding-inline-start: 30px;
    padding-inline-end: 20px;
    padding-bottom: 15px;
    font-size: 13px;
    max-width: calc(100% - 65px);
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .processes-history__affected-ids-container {
    margin-top: 8px;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    display: inline-block;
    align-self: flex-start;
    max-width: fit-content;
    word-break: break-word;
    overflow-wrap: break-word;

    &.processes-history__affected-ids--pending {
      background-color: ${orangeMui._50};
      color: ${orangeMui._700};
      border: 1px solid ${orangeMui._200};
    }

    &.processes-history__affected-ids--completed {
      background-color: ${blueMui._50};
      color: ${blueMui._700};
      border: 1px solid ${blueMui._200};
    }

    &.processes-history__affected-ids--failed {
      background-color: ${redMui._50};
      color: ${redMui._700};
      border: 1px solid ${redMui._200};
    }
  }

  .processes-history__metadata {
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 11px;
    margin-inline-start: 6px;
    padding: 4px 8px;
    border-radius: 12px;
    border: 1px solid;
    display: inline-block;

    &.processes-history__metadata--pending {
      background-color: ${orangeMui._50};
      color: ${orangeMui._700};
      border-color: ${orangeMui._200};
    }

    &.processes-history__metadata--completed {
      background-color: ${greenMui._50};
      color: ${greenMui._700};
      border-color: ${greenMui._200};
    }

    &.processes-history__metadata--failed {
      background-color: ${redMui._50};
      color: ${redMui._700};
      border-color: ${redMui._200};
    }
  }

  .processes-history__status--pending {
    color: ${orangeMui._700};
    font-weight: 600;
  }

  .processes-history__status--completed {
    color: ${greenMui._700};
    font-weight: 600;
  }

  .processes-history__status--failed {
    color: ${redMui._700};
    font-weight: 600;
  }

  .processes-history__grid-cell.processes-history__affected-ids {
    display: flex;
    flex-wrap: nowrap;
    gap: 6px;
    align-items: center;
    flex: 0 0 auto;
    min-width: auto;
    width: auto;
    padding: 8px 12px;
    overflow-x: auto;
  }

  .processes-history__affected-id {
    padding: 3px 8px;
    border-radius: 6px;
    border: 1px solid;
    font-size: 11px;
    font-weight: 500;
    display: inline-block;
    white-space: nowrap;
    flex-shrink: 0;

    &.processes-history__status--pending {
      background-color: ${orangeMui._50};
      color: ${orangeMui._700};
      border-color: ${orangeMui._200};
    }

    &.processes-history__status--completed {
      background-color: ${blueMui._50};
      color: ${blueMui._700};
      border-color: ${blueMui._200};
    }

    &.processes-history__status--failed {
      background-color: ${redMui._50};
      color: ${redMui._700};
      border-color: ${redMui._200};
    }
  }

  .processes-history__json-viewer {
    max-width: 100%;
    overflow-x: auto;

    .react-json-view {
      background-color: transparent;
      font-size: 13px;
    }

    .react-json-view .variable-value {
      color: ${rydeColors.grey};
    }

    .react-json-view .object-key {
      color: ${rydeColors.grey};
    }

    .react-json-view .string-value {
      color: ${rydeColors.grey};
    }

    .react-json-view .number-value {
      color: ${rydeColors.grey};
    }

    .react-json-view .boolean-value {
      color: ${rydeColors.grey};
    }

    .react-json-view .null-value {
      color: ${rydeColors.grey};
    }
  }
`;
